import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import Me from "../../helpers/me";
import App from "../../helpers/app";
import Api from "../../helpers/api";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { take } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { JwtHelper } from "../../helpers/jwt-helper";

@Component({
  selector: "app-servidores-conferidor",
  templateUrl: "./servidores-conferidor.component.html",
  styleUrls: ["./servidores-conferidor.component.scss"],
})
export class ServidoresConferidorComponent implements OnInit {
  apiCall = this.api.new().silent();
  page = 1;
  pageSize = 10;
  total = 0;
  urlToShow = null;
  idCidade;
  cidade = null;
  nomeCidade: string;
  podeExcluirMatricula = false;
  excluindoMatriculaId: number = null;
  
  servidores = [];
  servidoresFiltered = [];
  servidoresExpandidos: { [key: string]: boolean } = {};
  
  filterName;
  filterCpf;
  filterMatricula;
  filterStatus;
  filterDiverso = null;
  filterCreatedAt = {
    start: '',
    end: ''
  };
  filterBirthDate = {
    start: '',
    end: ''
  };
  
  statusServidor = [
    { id: 1, name: "Ativo" },
    { id: 2, name: "Aposentado" },
    { id: 3, name: "Pensionista" },
    { id: 4, name: "Exonerado" },
    { id: 5, name: "Falecido" },
  ];
  filtrosDiversosOpcoes = [
    { id: 'uma', name: 'Uma matrícula' },
    { id: 'multiplas', name: 'Múltiplas matrículas' },
    { id: 'com_dependentes', name: 'Servidores com dependentes' },
    { id: 'dependentes_deficientes', name: 'Servidores com dependentes deficientes' },
    { id: 'dependentes_maior_21', name: 'Servidores com dependentes maiores de 21 anos' },
  ];
  
  sortColumn: string = '';
  sortDirection: string = 'asc';
  
  dependentes = [];
  dependentesToShow = [];
  tempoTotalCadastrado = 0;
  tempoFiltradoCadastrado = 0;
  
  // Referência ao Math para uso no template
  Math = Math;
  
  // Variáveis para iniciar conferência
  servidorSelecionado: any = null;
  isIniciandoConferencia: boolean = false;
  
  // Variáveis para finalizar conferência
  servidorSelecionadoFinalizar: any = null;
  situacaoFinalizar: string = '';
  isFinalizandoConferencia: boolean = false;
  opcoesFinalizarConferencia = [
    { label: 'Conferido', value: 'conferido' },
  ];
  
  servidor: any = {
    nome: null,
    cpf: null,
    rg: null,
    data_nascimento: null,
    status: null,
    imagem: null,
    matricula: null,
    inicio_atendimento: null,
    fim_atendimento: null,
    statusNumero: null,
    salario: null,
    cargo: null,
    data_ingresso_ente: null,
    carga_horaria: null,
    telefone: null,
    pis_pasep: null,
    escolaridade: null,
    estado_civil: null,
    estado_naturalidade: null,
    cidade_naturalidade: null,
    idade_aposentadoria: null,
    concessao_aposentadoria: null,
    data_ingresso_servico_publico: null
  };

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private app: App,
    private http: HttpClient,
    private api: Api
  ) {}

  async ngOnInit() {
    const currentUser = this.me.currentUserValue;
    this.podeExcluirMatricula = !!(currentUser && currentUser.token &&
      JwtHelper.podeExcluirMatricula(currentUser.token));
    if (currentUser && currentUser.token && JwtHelper.isConferidor(currentUser.token)) {
      const permissoes: any = await this.apiCall
        .get('conferidores/me/permissoes')
        .pipe(take(1))
        .toPromise();
      if (permissoes && typeof permissoes.pode_excluir_matricula === 'boolean') {
        this.podeExcluirMatricula = permissoes.pode_excluir_matricula;
      } else {
        this.podeExcluirMatricula = false;
      }
    }
    this.route.queryParams.subscribe(async (params) => {
      this.idCidade = params.idCidade;
      if (this.idCidade) {
        await this.loadCidadeData();
        await this.loadServidores();
      }
    });
  }

  async loadCidadeData() {
    const self = this;
    try {
      const responseCidade = await self.apiCall
        .get("enderecos/cidade?id=" + this.idCidade)
        .pipe(take(1))
        .toPromise();
      
      if (responseCidade && responseCidade[0]) {
        self.cidade = responseCidade[0];
        self.nomeCidade = self.cidade.nome;
      }
    } catch (error) {
      console.error('Erro ao carregar dados da cidade:', error);
    }
  }

  private buildQueryParams(): string {
    const params = new URLSearchParams();
    
    const offset = (this.page - 1) * this.pageSize;
    if (offset > 0) {
      params.append('offset', offset.toString());
    }
    if (this.pageSize > 0) {
      params.append('limit', this.pageSize.toString());
    }
    
    if (this.filterName && this.filterName.trim()) {
      params.append('nome', this.filterName.trim());
    }
    
    if (this.filterCpf && this.filterCpf.trim()) {
      const cpfLimpo = this.filterCpf.toString().replace(/[^\d]/g, '');
      if (cpfLimpo) {
        params.append('cpf', cpfLimpo);
      }
    }
    
    if (this.filterMatricula && this.filterMatricula.toString().trim()) {
      params.append('matricula', this.filterMatricula.toString().trim());
    }
    
    if (this.filterStatus) {
      params.append('status', this.filterStatus.toString());
    }
    
    if (this.filterCreatedAt.start && this.filterCreatedAt.start.trim()) {
      params.append('data_cadastro_inicio', this.filterCreatedAt.start.trim());
    }
    if (this.filterCreatedAt.end && this.filterCreatedAt.end.trim()) {
      params.append('data_cadastro_fim', this.filterCreatedAt.end.trim());
    }
    
    if (this.filterBirthDate.start && this.filterBirthDate.start.trim()) {
      params.append('data_nascimento_inicio', this.filterBirthDate.start.trim());
    }
    if (this.filterBirthDate.end && this.filterBirthDate.end.trim()) {
      params.append('data_nascimento_fim', this.filterBirthDate.end.trim());
    }

    if (this.filterDiverso) {
      if (this.filterDiverso === 'uma' || this.filterDiverso === 'multiplas') {
        params.append('quantidade_matriculas', this.filterDiverso);
      } else {
        params.append('filtro_dependentes', this.filterDiverso);
      }
    }

    if (this.sortColumn) {
      const orderByMap: { [key: string]: string } = {
        nome: 'nome',
        cpf: 'cpf',
        matricula: 'matricula',
        status: 'status',
        conferencia: 'situacao_conferencia',
      };
      const orderBy = orderByMap[this.sortColumn];
      if (orderBy) {
        params.append('orderBy', orderBy);
        params.append('orderDirection', this.sortDirection.toUpperCase());
      }
    }
    
    return params.toString();
  }

  async loadServidores() {
    const self = this;
    
    if (!self.idCidade) {
      return;
    }

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const queryParams = self.buildQueryParams();
      const url = `conferidores/municipios/${self.idCidade}/servidores-prontos${queryParams ? '?' + queryParams : ''}`;
      
      const response = await self.apiCall
        .get(url)
        .pipe(take(1))
        .toPromise();

      const responseData = response ? JSON.parse(JSON.stringify(response)) : { data: [], total: 0, offset: 0, limit: 0 };
      
      // O endpoint agora retorna um objeto com data, total, offset e limit
      const lista = Array.isArray(responseData.data) ? responseData.data : [];
      
      // O backend faz paginação e retorna o total
      self.servidores = lista;
      self.servidoresFiltered = lista;
      self.servidoresExpandidos = {};
      
      // Usar o total retornado pelo backend
      self.total = responseData.total || 0;
      
      self.spinner.hide();
    } catch (error) {
      console.error('Erro ao carregar servidores:', error);
      self.spinner.hide();
      await self.app.alert('Erro!', 'Erro ao carregar servidores. Tente novamente.', 'error');
    }
  }

  async applyFilters() {
    this.page = 1;
    await this.loadServidores();
  }

  async clearFilters() {
    this.filterName = null;
    this.filterCpf = null;
    this.filterMatricula = null;
    this.filterStatus = null;
    this.filterDiverso = null;
    this.filterCreatedAt = { start: '', end: '' };
    this.filterBirthDate = { start: '', end: '' };
    this.page = 1;
    await this.loadServidores();
  }

  sortTable(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.page = 1;
    this.loadServidores();
  }

  getSortIcon(column: string): string {
    if (this.sortColumn === column) {
      return this.sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down';
    }
    return '';
  }

  isColumnSorted(column: string): boolean {
    return this.sortColumn === column;
  }

  classificaStatus(status: number): string {
    const statusMap = {
      1: 'ATIVO',
      2: 'APOSENTADO',
      3: 'PENSIONISTA',
      4: 'EXONERADO',
      5: 'FALECIDO'
    };
    return statusMap[status] || 'Desconhecido';
  }


  getStatusClass(status: number): string {
    return `status-${status}`;
  }


  getStatusColor(status: number): string {
    const colorMap = {
      1: '#28a745', // Verde para Ativo
      2: '#ff9800', // Laranja para Aposentado
      3: '#2196F3', // Azul para Pensionista
      4: '#f44336', // Vermelho para Exonerado
      5: '#f44336'  // Vermelho para Falecido
    };
    return colorMap[status] || '#6c757d';
  }

  getSituacaoConferencia(servidor: any): string {
    if (!servidor.situacao_nova) {
      return 'CONFERÊNCIA PENDENTE';
    }
    
    const situacaoMap = {
      'pendente': 'CONFERÊNCIA PENDENTE',
      'em_conferencia': 'EM CONFERÊNCIA',
      'conferido': 'CONFERIDO',
      'conferido_com_erro': 'CONFERIDO COM ERRO',
      'inconsistente': 'SITUAÇÃO INCONSISTENTE'
    };
    
    return situacaoMap[servidor.situacao_nova] || servidor.situacao_nova.toUpperCase();
  }

  getSituacaoConferenciaClass(servidor: any): string {
    const situacao = servidor && servidor.situacao_nova
      ? servidor.situacao_nova
      : 'pendente';
    const classMap = {
      'pendente': 'conferencia-pendente',
      'em_conferencia': 'conferencia-em-andamento',
      'conferido': 'conferencia-concluida',
      'conferido_com_erro': 'conferencia-com-erro',
      'inconsistente': 'conferencia-com-erro'
    };

    return classMap[situacao] || 'conferencia-pendente';
  }

  podeAcionarConferencia(servidor: any): boolean {
    const situacao = servidor && servidor.situacao_nova;
    return !situacao || situacao === 'pendente' || situacao === 'em_conferencia' || situacao === 'inconsistente';
  }

  getMatriculasServidor(servidor: any): any[] {
    return servidor && Array.isArray(servidor.matriculas) ? servidor.matriculas : [];
  }

  getStatusServidor(servidor: any): number[] {
    const status = this.getMatriculasServidor(servidor)
      .map(matricula => Number(matricula.status))
      .filter(valor => !!valor);
    return Array.from(new Set(status));
  }

  getMatriculaInicial(servidor: any): any {
    return this.getMatriculasServidor(servidor)[0] || null;
  }

  async excluirMatricula(servidor: any, matricula: any, event?: Event) {
    if (event) event.stopPropagation();
    if (!this.podeExcluirMatricula || !matricula || !matricula.id || this.excluindoMatriculaId) {
      return;
    }

    const numero = matricula.matricula || 'sem número';
    const motivo = await this.app.solicitarMotivo(
      'Excluir matrícula',
      `A matrícula ${numero} de ${servidor.nome} será retirada da conferência. Informe o motivo para continuar.`
    );
    if (!motivo) return;

    this.excluindoMatriculaId = Number(matricula.id);
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });

    try {
      const response: any = await this.apiCall
        .post(`conferidores/matriculas/${matricula.id}/exclusao`, { motivo })
        .pipe(take(1))
        .toPromise();
      if (!response || response.success !== true) {
        const message = response && response.error && response.error.message
          ? response.error.message
          : response && response.message
            ? response.message
            : 'Não foi possível excluir a matrícula.';
        throw new Error(message);
      }
      await this.app.alert('Sucesso!', response.message, 'success');
      await this.loadServidores();
    } catch (error) {
      await this.app.alert(
        'Erro!',
        error && error.message ? error.message : 'Não foi possível excluir a matrícula.',
        'error'
      );
    } finally {
      this.excluindoMatriculaId = null;
      this.spinner.hide();
    }
  }

  getMatriculaParaConferencia(servidor: any): any {
    const matriculas = this.getMatriculasServidor(servidor);
    return matriculas.find(matricula => matricula.situacao === 'em_conferencia')
      || matriculas.find(matricula => !matricula.situacao || matricula.situacao === 'pendente')
      || matriculas[0]
      || null;
  }

  getQuantidadeMatriculasPendentes(servidor: any): number {
    return this.getMatriculasServidor(servidor)
      .filter(matricula => !matricula.situacao || matricula.situacao === 'pendente')
      .length;
  }

  toggleServidor(servidor: any) {
    if (!servidor) return;
    const chave = String(servidor.id);
    this.servidoresExpandidos[chave] = !this.servidoresExpandidos[chave];
  }

  isServidorExpanded(servidor: any): boolean {
    return !!(servidor && this.servidoresExpandidos[String(servidor.id)]);
  }

  getTituloAcaoConferencia(servidor: any): string {
    const situacao = servidor && servidor.situacao_nova;
    if (situacao === 'em_conferencia') return 'Retomar ou finalizar conferência';
    if (situacao === 'inconsistente') return 'Continuar matrículas pendentes';
    if (situacao === 'conferido' || situacao === 'conferido_com_erro') {
      return 'Conferência finalizada';
    }
    return 'Iniciar conferência';
  }

  acionarConferencia(modalIniciar: any, modalServidorEmConferencia: any, servidor: any) {
    if (!this.podeAcionarConferencia(servidor)) return;
    if (servidor && servidor.situacao_nova === 'em_conferencia') {
      this.abrirModalServidorEmConferencia(modalServidorEmConferencia, servidor);
      return;
    }
    this.abrirModalIniciarConferencia(modalIniciar, servidor);
  }

  async onPageChange() {
    await this.loadServidores();
  }

  viewMidia(url: string, content: any) {
    this.urlToShow = url;
    this.modalService.open(content, {
      centered: true,
      size: 'lg',
      backdrop: true,
      backdropClass: 'modal-backdrop-transparente',
      keyboard: true
    });
  }

  async getRelatorioServidor(modal: any, servidorLinha: any) {
    const self = this;
    const servidorId = servidorLinha && servidorLinha.id;
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const servidor = await self.apiCall
        .get(`servidor?id=${servidorId}&id_cidade=${self.idCidade}&id_matricula=${servidorLinha.id_matricula}`)
        .pipe(take(1))
        .toPromise();

      const servidorData = servidor ? JSON.parse(JSON.stringify(servidor)) : null;
      
      if (servidorData) {
        self.servidor = servidorData;
        self.servidor.statusNumero = servidorData.status;
        
        // Carregar dependentes
        const dependentesResponse = await self.apiCall
          .get(`servidor/dependentes?id=${servidorId}`)
          .pipe(take(1))
          .toPromise();
        
        self.dependentes = dependentesResponse ? JSON.parse(JSON.stringify(dependentesResponse)) : [];
        self.dependentesToShow = self.dependentes.map(dep => ({
          ...dep,
          idade: dep.data_nascimento ? self.calculateAge(dep.data_nascimento) : '-',
          tipo_dependencia_label: self.getTipoDependenciaLabel(dep.tipo_dependencia)
        }));
        
        // Calcular tempos
        if (servidorData.tempos && servidorData.tempos.length > 0) {
          self.tempoTotalCadastrado = servidorData.tempos.reduce((acc, t) => acc + (t.dias || 0), 0);
          self.tempoFiltradoCadastrado = servidorData.tempos
            .filter(t => t.tipo === 'INSS')
            .reduce((acc, t) => acc + (t.dias || 0), 0);
        }
        
        self.modalService.open(modal, {
          centered: true,
          size: 'xl',
          backdrop: true,
          backdropClass: 'modal-backdrop-transparente',
          keyboard: true
        });
      }
      
      self.spinner.hide();
    } catch (error) {
      console.error('Erro ao carregar servidor:', error);
      self.spinner.hide();
      await self.app.alert('Erro!', 'Erro ao carregar dados do servidor.', 'error');
    }
  }

  calculateAge(dataNascimento: string): number {
    if (!dataNascimento) return 0;
    const birthDate = new Date(dataNascimento);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  getTipoDependenciaLabel(tipo: number): string {
    const tipos = {
      1: 'Cônjuge',
      2: 'Filho(a)',
      3: 'Companheiro(a)',
      4: 'Pai/Mãe',
      5: 'Irmão(ã)',
      6: 'Outros'
    };
    return tipos[tipo] || 'Desconhecido';
  }

  beautifulDate(date: string): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString('pt-BR');
  }

  beautifulDateSimple(date: string): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString('pt-BR');
  }

  getYear(date: string): number {
    if (!date) return new Date().getFullYear();
    return new Date(date).getFullYear();
  }

  formatToBRLCurrency(value: number): string {
    if (!value) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  goBack() {
    this.router.navigate(['/page/conferidor/municipios']);
  }
  
  // Método auxiliar para calcular o máximo de itens exibidos
  getMaxItemsDisplayed(): number {
    if (this.total === 0) return 0;
    return Math.min(this.page * this.pageSize, this.total);
  }
  
  // Abrir modal de iniciar conferência
  abrirModalIniciarConferencia(modal: any, servidor: any) {
    this.servidorSelecionado = servidor;
    this.modalService.open(modal, {
      centered: true,
      size: 'md',
      backdrop: true,
      backdropClass: 'modal-backdrop-transparente',
      keyboard: true
    });
  }
  
  // Iniciar conferência
  async iniciarConferencia(modal: any) {
    const self = this;
    
    if (!self.servidorSelecionado || !self.servidorSelecionado.id || !self.idCidade) {
      await self.app.alert('Erro!', 'Dados insuficientes para iniciar a conferência.', 'error');
      return;
    }
    
    self.isIniciandoConferencia = true;
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    
    try {
      // Obter ID do conferidor do token JWT
      const currentUser = self.me.currentUserValue;
      let idConferidor = null;
      
      if (currentUser && currentUser.token) {
        const decodedToken = JwtHelper.decodeToken(currentUser.token);
        idConferidor = decodedToken?.sub || null;
      }
      
      // Preparar dados para a requisição
      const dadosEstatistica: any = {
        id_servidor: self.servidorSelecionado.id,
        id_cidade: self.idCidade,
        situacao: 'em_conferencia',
        observacoes: 'Conferência iniciada pelo conferidor'
      };
      
      // Adicionar id_conferidor se disponível
      if (idConferidor) {
        dadosEstatistica.id_conferidor = idConferidor;
      }
      
      // Chamar endpoint para registrar ação de conferência
      const response = await self.apiCall
        .post('conferidores/estatisticas/acao-servidor', dadosEstatistica)
        .pipe(take(1))
        .toPromise();
      
      const responseData = response ? JSON.parse(JSON.stringify(response)) : null;
      
      if (responseData && responseData.success) {
        self.spinner.hide();
        modal.close('Conferência iniciada');
        
        // Mostrar mensagem de sucesso
        await self.app.alert('Sucesso!', 'Conferência iniciada com sucesso!', 'success');
        
        // Redirecionar para página de auditoria (usando servidor-novo)
        self.router.navigate(['/page/servidorv2'], {
          queryParams: {
            id: self.servidorSelecionado.id,
            idCidade: self.idCidade,
            id_matricula: self.getMatriculaParaConferencia(self.servidorSelecionado)?.id
          }
        });
      } else {
        throw new Error(responseData?.message || 'Erro ao iniciar conferência');
      }
    } catch (error) {
      console.error('Erro ao iniciar conferência:', error);
      self.spinner.hide();
      self.isIniciandoConferencia = false;
      await self.app.alert('Erro!', error.message || 'Erro ao iniciar conferência. Tente novamente.', 'error');
    }
  }
  
  // Abrir modal de retomada ou finalização da conferência
  abrirModalServidorEmConferencia(modal: any, servidor: any) {
    this.servidorSelecionadoFinalizar = servidor;
    this.situacaoFinalizar = '';
    this.isFinalizandoConferencia = false;
    this.modalService.open(modal, {
      centered: true,
      size: 'md',
      backdrop: true,
      keyboard: true
    });
  }

  async submeterConferenciaEmAndamento(modal: any) {
    if (this.situacaoFinalizar) {
      await this.finalizarConferencia(modal);
      return;
    }

    if (!this.servidorSelecionadoFinalizar || !this.servidorSelecionadoFinalizar.id || !this.idCidade) {
      await this.app.alert('Erro!', 'Dados insuficientes para retomar a conferência.', 'error');
      return;
    }

    modal.close('Conferência retomada');
    this.retomarConferencia(this.servidorSelecionadoFinalizar);
  }
  
  // Finalizar conferência
  async finalizarConferencia(modal: any) {
    const self = this;
    
    if (!self.servidorSelecionadoFinalizar || !self.servidorSelecionadoFinalizar.id || !self.idCidade || !self.situacaoFinalizar) {
      await self.app.alert('Erro!', 'Selecione uma opção para finalizar a conferência.', 'error');
      return;
    }
    
    self.isFinalizandoConferencia = true;
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    
    try {
      // Obter ID do conferidor do token JWT
      const currentUser = self.me.currentUserValue;
      let idConferidor = null;
      
      if (currentUser && currentUser.token) {
        const decodedToken = JwtHelper.decodeToken(currentUser.token);
        idConferidor = decodedToken?.sub || null;
      }
      
      // Preparar dados para a requisição
      const dadosEstatistica: any = {
        id_servidor: self.servidorSelecionadoFinalizar.id,
        id_cidade: self.idCidade,
        situacao: self.situacaoFinalizar,
        observacoes: `Conferência finalizada como ${self.situacaoFinalizar}`
      };
      
      // Adicionar id_conferidor se disponível
      if (idConferidor) {
        dadosEstatistica.id_conferidor = idConferidor;
      }
      
      // Chamar endpoint para registrar ação de conferência
      const response = await self.apiCall
        .post('conferidores/estatisticas/acao-servidor', dadosEstatistica)
        .pipe(take(1))
        .toPromise();
      
      const responseData = response ? JSON.parse(JSON.stringify(response)) : null;
      
      if (responseData && responseData.success) {
        self.spinner.hide();
        modal.close('Conferência finalizada');
        
        // Mostrar mensagem de sucesso
        await self.app.alert('Sucesso!', 'Conferência finalizada com sucesso!', 'success');
        
        // Recarregar lista de servidores
        await self.loadServidores();
      } else {
        throw new Error(responseData?.message || 'Erro ao finalizar conferência');
      }
    } catch (error) {
      console.error('Erro ao finalizar conferência:', error);
      self.spinner.hide();
      self.isFinalizandoConferencia = false;
      await self.app.alert('Erro!', error.message || 'Erro ao finalizar conferência. Tente novamente.', 'error');
    }
  }
  
  // Retomar conferência (redirecionar para tela de edição)
  retomarConferencia(servidor: any) {
    if (!servidor || !servidor.id || !this.idCidade) {
      this.app.alert('Erro!', 'Dados insuficientes para retomar a conferência.', 'error');
      return;
    }
    
    this.router.navigate(['/page/servidorv2'], {
      queryParams: {
        id: servidor.id,
        idCidade: this.idCidade,
        id_matricula: this.getMatriculaParaConferencia(servidor)?.id
      }
    });
  }
}
